import { Link } from "react-router-dom";

export const TopBanner = () => {
  return (
    <div className="bg-primary text-primary-foreground">
      <div className="container flex flex-col sm:flex-row items-center justify-center gap-2 py-2.5 text-sm text-center">
        <span>
          A Aceena encerrou suas atividades. Clientes com contrato ativo: fale
          diretamente com sua locadora.
        </span>
        <Link
          to="/"
          className="underline underline-offset-2 hover:text-aceena-green transition-colors font-semibold"
        >
          Saiba mais
        </Link>
      </div>
    </div>
  );
};
